import React from "react";

function Projects() {
  return (
    <>
      <div name="portfolio" className=" w-full text-white">
        <div className="max-w-screen-lg  mx-auto flex flex-col justify-center w-full h-full">
          <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              My Projects!
            </p>
            <p className="py-6">Check out some of my work right here.</p>
          </div>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/Screenshot%20(491).png?alt=media&token=a1763d7d-4a0e-46d6-9d9c-2073b6ddbc17&_gl=1*1un7268*_ga*ODQ0MTE3MzI0LjE2OTg0ODg5MDc.*_ga_CW55HF8NVT*MTY5ODczOTg5OS44LjEuMTY5ODc0MTI2NS41MS4wLjA."
                height="500"
              />
              <center>
                <h2 className="">e-hungry : Website to order food online!</h2>
              </center>
              <div className="flex items-center justify-center">
                <center>
                  <a
                    href="https://statuesque-kelpie-e69378.netlify.app/"
                    target="false"
                  >
                    <button className="w-full px-5 py-3 m-4 duration-200 hover:scale-105">
                      Demo
                    </button>
                  </a>
                </center>
              </div>
            </div>
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/Screenshot%20(489).png?alt=media&token=448b7a79-0894-4310-a4ce-5c2b0cdb34e8&_gl=1*1r2fwnz*_ga*ODQ0MTE3MzI0LjE2OTg0ODg5MDc.*_ga_CW55HF8NVT*MTY5ODczOTg5OS44LjEuMTY5ODc0MTA5OS41NC4wLjA."
                height="500"
              />
              <center>
                <h2 className="">
                  AI Powered platform for Interview Preparation
                </h2>
              </center>
              <div className="flex items-center justify-center">
                <center>
                  <a href="https://www.linked-list.co.in/" target="false">
                    <button className="w-full px-5 py-3 m-4 duration-200 hover:scale-105">
                      Demo
                    </button>
                  </a>
                </center>
              </div>
            </div>
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/Screenshot%20(380).png?alt=media&token=0590d615-cced-4a07-840f-e4bada80a070"
                height="500"
              />
              <center>
                <h2 className="">
                  Create Rooms and solve/compete DSA problems with your friends.
                </h2>
              </center>
              <div className="flex items-center justify-center">
                <center>
                  <a href="" target="false">
                    <button className="w-full px-5 py-3 m-4 duration-200 hover:scale-105">
                      Check here
                    </button>
                  </a>
                </center>
              </div>
            </div>
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <img src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/Screenshot%20(377).png?alt=media&token=3cd9768d-84a6-4dc1-9f87-687f955fdca6" />
              <center>
                <h2>Using React.js and Open Ai API.</h2>
              </center>
              <div className="flex items-center justify-center">
                <a
                  href="https://main--brilliant-kringle-a315e4.netlify.app/"
                  target="false"
                >
                  <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                    Demo
                  </button>
                </a>
              </div>
            </div>
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <center>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/i.png?alt=media&token=3de412da-03e0-4ded-bb5b-f41363bf47ac"
                  width="200"
                />
                <h2 className="">
                  Social media Clone using Django,Html,CSS and AWS RDS.
                </h2>
              </center>

              <div className="flex items-center justify-center">
                <a
                  href="https://github.com/Rhythmbat205/Social-media-Clone"
                  target="false"
                >
                  <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                    Code
                  </button>
                </a>
              </div>
            </div>
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <img src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/Screenshot%20(378).png?alt=media&token=0c069b65-72d8-4561-94fb-8451e86df0ff" />
              <h2>Github Finder using Github API and React</h2>
              <div className="flex items-center justify-center">
                <a
                  href="https://github-finder-app-blue.vercel.app/"
                  target="false"
                >
                  <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                    Demo
                  </button>
                </a>
              </div>
            </div>
            <div className="shadow-md shadow-gray-600 rounded-lg">
              <img src="https://firebasestorage.googleapis.com/v0/b/personal-portfolio-6f924.appspot.com/o/Screenshot%20(379).png?alt=media&token=b8b92b43-65b5-47c5-aaf1-785043f40843" />
              <h2>Feedback collecting web app using React.js</h2>
              <div className="flex items-center justify-center">
                <a href="https://feedback-app2.netlify.app/" target="false">
                  {" "}
                  <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                    Demo
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
